import React from 'react'
import { Section } from '@/components/shared/section/Section'
import { env } from '@/utils/constants/env'

export const ListKehadiran: React.FC = () => {
  return (
    <Section title="Dashboard Kehadiran & Order Makan Siang">
      <div className="flex flex-col items-center gap-1 p-10">
        <iframe
          data-testid="dashboard-iframe"
          src={env.iFrameMetabaseKehadiran}
          frameBorder="0"
          width="100%"
          height="1500"
          allowTransparency
        ></iframe>
      </div>
    </Section>
  )
}
